(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-product-template"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="catalog-product-"]').forEach((section) => {
    if (section.dataset.cpReady) return;
    section.dataset.cpReady = 'true';
    const quantity = section.querySelector('input[name="quantity"]');
    section.querySelector('[data-cp-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    section.querySelector('[data-cp-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    const stage = section.querySelector('[data-cp-stage]');
    const slides = [...section.querySelectorAll('[data-cp-slide]')];
    const thumbs = [...section.querySelectorAll('[data-cp-thumb]')];
    let current = 0;
    const goTo = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      stage?.scrollTo({ left: current * stage.clientWidth, behavior: 'smooth' });
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === current));
      const thumbRail = thumbs[current]?.parentElement;
      if (thumbRail && thumbs[current]) thumbRail.scrollTo({ left: thumbs[current].offsetLeft - thumbRail.offsetLeft, behavior: 'smooth' });
    };
    section.querySelectorAll('[data-cp-prev]').forEach((button) => button.addEventListener('click', () => goTo(current - 1)));
    section.querySelectorAll('[data-cp-next]').forEach((button) => button.addEventListener('click', () => goTo(current + 1)));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index))));
    stage?.addEventListener('scroll', () => {
      if (!stage.clientWidth) return;
      const index = Math.round(stage.scrollLeft / stage.clientWidth);
      if (index !== current) { current = index; thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === current)); }
    }, { passive: true });
    const lightbox = section.querySelector('[data-cp-lightbox]');
    const lightboxImage = section.querySelector('[data-cp-lightbox-image]');
    section.querySelectorAll('[data-cp-zoom]').forEach((button) => button.addEventListener('click', () => {
      const image = slides[current]?.querySelector('img');
      if (!image || !lightbox || !lightboxImage) return;
      lightboxImage.src = image.currentSrc || image.src;
      lightboxImage.alt = image.alt;
      lightbox.showModal();
    }));
    section.querySelector('[data-cp-close]')?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
    const variantPicker = section.querySelector('[data-cp-variant]');
    variantPicker?.addEventListener('change', () => {
      const selected = variantPicker.options[variantPicker.selectedIndex];
      const price = section.querySelector('[data-cp-price]');
      const value = price?.querySelector('span');
      if (value) value.textContent = selected.dataset.price;
      let compare = price?.querySelector('s');
      if (selected.dataset.compare) { if (!compare) { compare = document.createElement('s'); price.insertBefore(compare, price.querySelector('small')); } compare.textContent = selected.dataset.compare; }
      else if (compare) compare.remove();
      const inventory = section.querySelector('[data-cp-inventory]');
      if (inventory) {
        const count = Number(selected.dataset.inventory || 0);
        const tracked = selected.dataset.tracked === 'true';
        const threshold = Number(inventory.dataset.threshold || 0);
        inventory.hidden = !tracked || count <= 0 || count > threshold;
        const message = inventory.querySelector('[data-cp-inventory-text]');
        if (message) message.textContent = (section.dataset.inventoryText || 'Only [count] left in stock!').replace('[count]', String(count));
      }
    });
    const countdown = section.querySelector('[data-cp-countdown]');
    if (countdown) {
      const end = new Date(countdown.dataset.end).getTime();
      const output = countdown.querySelector('[data-cp-timer]');
      const tick = () => {
        const remaining = end - Date.now();
        if (!Number.isFinite(end) || remaining <= 0) { countdown.hidden = true; return; }
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        output.textContent = days ? `${days}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}` : `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      };
      tick();
      window.setInterval(tick, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diya-shape-hanging-light"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="diya-page-"]').forEach((section) => {
    const quantity = section.querySelector('input[name="quantity"]');
    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    section.querySelector('[data-qty-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    const variantPicker = section.querySelector('[data-diya-variant]');
    variantPicker?.addEventListener('change', () => {
      const selected = variantPicker.options[variantPicker.selectedIndex];
      const price = section.querySelector('[data-diya-price]');
      const value = price.querySelector('span'); if (value) value.textContent = selected.dataset.price;
      let compare = price.querySelector('s');
      if (selected.dataset.compare) { if (!compare) { compare = document.createElement('s'); price.insertBefore(compare, price.querySelector('small')); } compare.textContent = selected.dataset.compare; }
      else if (compare) compare.remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
